import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccountLink } from '@/lib/navigation/links/AccountLink';
import { ActionStatus } from 'thunkless';
import { UILoader } from '../ui-elements/UILoader';
import {
  orgCancelSubscriptionSelector,
  orgSubscriptionEndSelector,
} from '../../../redux/app/selectors/organization';
import { cancelSubscription } from '../../../redux/app/actions/organization';
import { NavigationPaneRouteParamsContext } from '../../../lib/navigation';

interface CancellationModalProps { hideModal: () => void }

export const CancellationModal = ({ hideModal }: CancellationModalProps) => {
  const dispatch = useDispatch();
  const cancelSub = useSelector(orgCancelSubscriptionSelector);
  const subscriptionEnd = useSelector(orgSubscriptionEndSelector);
  const { subdomain } = React.useContext(NavigationPaneRouteParamsContext);

  const [reason, setReason] = React.useState('');
  const [feedback, setFeedback] = React.useState('');

  const handleConfirmCancel = () => dispatch(cancelSubscription({ subdomain, reason, feedback }));

  const options = [
    'I never really started using Avochato',
    'I find Avochato difficult to use',
    'Pausing subscription temporarily',
    'My company doesn\'t have the staff to text',
    'My business is seasonal and I don\'t need to text right now',
    'I only text occasionally and don\'t need a monthly subscription',
    'Texting deliverability is too unreliable',
    'I had a bad customer service experience',
    'Other',
  ].map((str) => <option value={str}>{str}</option>);

  const confirmationContainerClass = `confirmation-modal-container cancellation ${cancelSub.status === ActionStatus.SUCCESS && 'cancel-success'}`;

  return (
    <div className="confirmation-modal">
      <div className="confirmation-modal-container-wrap">
        <div className={confirmationContainerClass}>
          {cancelSub.status === ActionStatus.SUCCESS && (
            <>
              <h2 className="align-self-c mb-20">{cancelSub.message}</h2>
              <AccountLink path="billing">
                <span className="button pale-green md align-self-c">Back to Billing</span>
              </AccountLink>
            </>
          )}
          {cancelSub.status === ActionStatus.BUSY && <UILoader />}
          {(!cancelSub.status || cancelSub.status === ActionStatus.FAILURE) && (
            <>
              <div className="content">
                <h2>Cancel Subscription</h2>
                <br />
                <p>
                  Are you sure you want to cancel your subscription?
                  <br />
                  You&apos;ll be able use Avochato until&nbsp;
                  {subscriptionEnd}
                  , after that you will no longer have access to your balance.
                </p>
              </div>
              <div className="width-100">
                <p className="mt-5 mb-5">Reason:</p>
                <div className="select-wrapper">
                  <select className="mb-10" onChange={(e) => setReason(e.currentTarget.value)}>
                    <option value="" disabled selected>Select a Reason</option>
                    {options}
                  </select>
                </div>
                <p className="mb-5">Feedback:</p>
                <textarea onChange={(e) => setFeedback(e.currentTarget.value)} />
                <div className="flex justify-center align-center" style={{ height: '40px' }}>
                  { cancelSub.status === ActionStatus.FAILURE && <p className="red fsz-11">{cancelSub.message}</p> }
                </div>
              </div>
              <div className="flex-end">
                <button
                  type="button"
                  className="button pale-green md"
                  onClick={hideModal}
                >
                  Nevermind
                </button>
                <button
                  type="button"
                  className="confirmation-button button md red"
                  onClick={handleConfirmCancel}
                >
                  Confirm
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
